<div class="footer-container">
    <div class="scene-footer">
      <div class="form-row">
        <div class="col-8">
          <!-- <p>© 2022 {{'footerpage.logo' | translate}}.</p> -->
          <p> {{'footerpage.hostedby' | translate }} @ {{ 'footerpage.allrightsreserved' | translate }}</p>
        </div>
        <div class="col-4 text-right">
          <p>{{'footerpage.poweredby' | translate}} <a href="http://vassarlabs.com/" target="_blank"> <img class="vassar-logo" src="../assets/images/footer-logo.png"></a> 
            <!-- in collaboration with <img src="../assets/images/logo.svg"> -->
           </p>
        </div>
      </div>
    </div>
  </div>